<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title class="subtitle-1 font-weight-bold">Manage Property Listings</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-select
        dense
        :items="items"
        v-model="type"
        item-text="name"
        item-value="value"
        @change="$emit('change', type)"
        label="Status"
        class="status-select"
      ></v-select>
      <download-csv ref="export" :data="table">
        <v-btn depressed class="mr-2 primary" tile>Export</v-btn>
      </download-csv>
      <Create></Create>
    </v-toolbar>
    <v-divider />
  </div>
</template>

<script>
import Create from "./Create";
export default {
  components: {
    Create
  },
  data() {
    return {
      type: "no",
      items: [
        {
          name: "All",
          value: "all"
        },
        {
          name: "Rented",
          value: "yes"
        },
        {
          name: "Not Rented",
          value: "no"
        }
      ]
    };
  },
  computed: {
    table() {
      let list = [];
      let table = this.$store.getters.table;
      table.forEach(item => {
        let { status, days, name, date, count } = item;
        let doc = {
          "Listing Address": name,
          "Listing Date": date,
          Status: status === "no" ? "Not Rented" : "Rented",
          "Days on Market": days,
          "Total Applications": count
        };
        if (status === this.type || this.type === "all") {
          list.push(doc);
        }
      });
      return list;
    }
  },
  methods: {},
  mounted() {}
};
</script>

<style>
.status-select {
  max-width: 150px !important;
  margin-top: 20px !important;
  margin-right: 10px !important;
}
</style>
